import { render, staticRenderFns } from "./RegisterVehicle.vue?vue&type=template&id=07954a37&scoped=true"
import script from "./RegisterVehicle.vue?vue&type=script&lang=js"
export * from "./RegisterVehicle.vue?vue&type=script&lang=js"
import style0 from "./RegisterVehicle.vue?vue&type=style&index=0&id=07954a37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07954a37",
  null
  
)

export default component.exports